import React from "react";
import { Card, CardBody, Col, Table } from "reactstrap";
import { Link } from "react-router-dom";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";
import { appointmentTableData, monthlyDropdownList } from "../../../Data/Dashboard/Default";
import { dynamicImage } from "../../../Utils";
import { Btn, P } from "../../../AbstractElements";

const Appointment = () => {
  return (
    <Col xl="4" md="7" className="xl-40 box-col-5">
      <Card className="appointment-detail">
        <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Overall Appointment"} />
        <CardBody>
          <div className="table-responsive theme-scrollbar">
            <Table>
              <tbody>
                {appointmentTableData.map((data, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex">
                        <img src={dynamicImage(`dashboard/appointment/0${index + 1}.png`)} className="img-fluid align-top circle" alt=""/>
                        <div className="flex-grow-1">
                          <Link to={`${process.env.PUBLIC_URL}/users/user_profile`}>
                            <span>{data.name}</span>
                          </Link>
                          <P className="mb-0">{data.time}</P>
                        </div>
                        <div className={`active-status active-${data.statusClass}`}/>
                      </div>
                    </td>
                    <td>{data.date}</td>
                    <td className="text-end">
                      <Btn color="transparent" className={`background-light-${data.color}`}>
                        {data.buttonText === "Done" ? (
                          <>
                            {data.buttonText}
                            <i className="fa fa-check-circle ms-1" />
                          </>
                        ) : (
                          data.buttonText
                        )}
                      </Btn>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Appointment;
